var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SettingsSection",
    {
      attrs: {
        title: _vm.t("activity", "Activity"),
        description: _vm.settingDescription,
      },
    },
    [_c("ActivityGrid"), _vm._v(" "), _c("EmailSettings")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }